import { DialogActions, DialogActionsProps, styled } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';

import { PoolModalContextValue, usePoolModalContext } from '../pool-modal';

type StyledDialogActionsProps = Pick<PoolModalContextValue, 'maxWidth'>;

const StyledDialogActions = styled(DialogActions, {
    shouldForwardProp: prop => prop !== 'maxWidth',
})<StyledDialogActionsProps>(({ theme, maxWidth }) => ({
    display: 'flex',
    justifyContent: maxWidth === 'lg' ? 'flex-end' : 'space-between',
    padding: theme.spacing(3, 11),

    '& > :not(:first-of-type)': {
        marginLeft: maxWidth === 'lg' ? theme.spacing(3) : 0,
    },
}));

export const PoolModalActions = (props: PropsWithChildren & DialogActionsProps): ReactElement => {
    const { children, ...dialogActionsProps } = props;
    const { maxWidth } = usePoolModalContext();

    return (
        <StyledDialogActions maxWidth={maxWidth} {...dialogActionsProps}>
            {children}
        </StyledDialogActions>
    );
};
